export default {
    route:{
        demo: '我的样例'
    },
    project:{
        demo: {
            demoName: '样例名称',
            demoCode: '样例代码'
        },
        user:{
            userName: '用户姓名',
            userLogin: '用户登录'
        },
        role:{
            roleName: '角色名称'
        },
        goods:{
            addGoods: '+',
            subGoods: '-',
            setGoodsName:'设置商品名称'
        },
        org:{
            routerList:'获取机构路由列表'
        }
    },
    httpCode:{
        http404: '404 错误'
    }
}